export const RoleMenu: any = {
  patoffhighway_view: [
    '/customer_planning',
    '/customer-level-screen',
    '/Engine-model-level',
    '/price-planning-em-level',
    '/deepdive',
    '/account-classification',
    '/customer-planning',
    '/first-screen',
    '/controller',
    '/weightage_score',
    '/price_planning',
  ]
};
